import type { RequestInterceptor } from '../types';

/**
 * Applies the correct `Content-Type` header
 * based on the type of `config.data`.
 */
export const contentType: RequestInterceptor = (config) => {
  config.headers['Content-Type'] = config.data instanceof FormData ? 'multipart/form-data' : 'application/json';
  return config;
};
